// @flow
export const FooterLocale = {
  description_panel: {
    content: [
      "With our extensive products and services that are shaped according to your business, we are here for all your needs on inventory counting.",
      "Müşterilerimizin gereksinimlerine göre şekillenen 360 derecelik ürün ve hizmetimizle, envanter sayım alanında ihtiyaç duyduğunuz her şey."]
  },
  company: {
    title: ["Company", "Firmamız"],
    about: ["About Us", "Hakkımızda"],
    contact: ["Contact", "İletişim"]
  },
  product: {
    title: ["Our Services", "Hizmetlerimiz"],
    processing: ["Inventory Counting", "Envanter Sayımları"],
    hrsolutions: ["HR Solutions", "İK Çözümleri"],
    partners: ["Solution Partners", "Envanterium Çözüm Ortakları"]
  },
  action_panel: {
    action: ["JOIN ENVANTERIUM", "ENVANTERIUM'A DAHİL OL"]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/Footer/Footer.locale.js